import {CdkStepper} from '@angular/cdk/stepper';
import {Component, ViewChild, ChangeDetectorRef, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import {Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {MatDialog} from '@angular/material';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {ConnectorsService} from '../connectors.service';


@Component({
    selector: 'app-cognitive-search-new',
    templateUrl: './cognitive-search-new.component.html',
    styleUrls: ['./cognitive-search-new.component.scss']
})
export class CognitiveSearchNewComponent implements OnInit {

    planName = '';
    version = '';
    category = '';
    description = '';
    @ViewChild('stepper') stepper!: MatStepper;
    selectedStepIndex = 0;
    isNextClicked = false;
    isLinear = true;
    cloudFormGroup!: FormGroup;
    chunkingFormGroup!: FormGroup; // Add chunking form group
    indexconfigFormGroup!: FormGroup; // Add embedding form group
    documentReceiverFormGroup!: FormGroup;
    deployIndexEndpointsFormGroup!: FormGroup; // Add the non-null assertion operator here
    createIndexEndpointsFormGroup!: FormGroup; // Add the non-null assertion operator here
    createIndexFormGroup!: FormGroup; // Add the non-null assertion
    choiceOfLlmFormGroup!: FormGroup; // Add the non-null assertion
    contextGenerationStrategyFormGroup!: FormGroup; // Add the non-null assertion
    searchtextFormGroup!: FormGroup; // Add the non-null assertion
    deploymentFormGroup!: FormGroup; // Add the non-null assertion

    connectors: any;
    selectedConnectorsList: any = [];
    selectedProvider: any = 'Google';
    cloudProviders = [
        {label: 'Google', imageSrc: ''},
    ];
    project_name: any;
    bucket_name: any;
    location: any;
    selectedEmbedding: any = 'textembedding-gecko@001';
    geckoEmbeddings: any;
    selectedDataFormat: any = 'structured';
    selectedFileType: any;
    selectedChunkingStrategy: any;
    overlapEnabled = false;
    chunkOverlap: any;
    chunkSize: any;
    componentLoading = true;
    indexDisplayName: any;
    indexDescription: any;
    indexEndpointDisplayName: any;
    indexEndpointDescription: any;
    dimensions: any;
    approximateNeighborsCount: any;
    distanceMeasureType: any;
    algorithmConfig = 'Tree-AH algorithm';
    leafNodeEmbeddingCount = 500;
    fractionLeafNodesToSearch = 0.8;
    shardSize = 'SHARD_SIZE_MEDIUM';


    constructor(private _formBuilder: FormBuilder, private cdr: ChangeDetectorRef,
                public platform: LeftpanelComponent,
                private connectorsService: ConnectorsService,
                public router: Router,
                private confPost: ConfService,
                public dialog: MatDialog) {
    }

    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        await this.getConnectorsData();
        this.loadEmbeddings();
        this.cloudFormGroup = this._formBuilder.group({});
        this.chunkingFormGroup = this._formBuilder.group({});
        this.indexconfigFormGroup = this._formBuilder.group({});
        this.documentReceiverFormGroup = this._formBuilder.group({});
        this.deployIndexEndpointsFormGroup = this._formBuilder.group({});
        this.createIndexEndpointsFormGroup = this._formBuilder.group({});
        this.createIndexFormGroup = this._formBuilder.group({});
        this.choiceOfLlmFormGroup = this._formBuilder.group({});
        this.contextGenerationStrategyFormGroup = this._formBuilder.group({});

        this.searchtextFormGroup = this._formBuilder.group({});
        this.deploymentFormGroup = this._formBuilder.group({});
    }

    loadEmbeddings() {
        if (this.selectedProvider === 'Google') {
            // this.embeddingService.getEmbeddings().subscribe(
            //     embeddings => {
            //       this.geckoEmbeddings = of(embeddings);
            //     },
            //     error => {
            //       console.error('Error fetching embeddings:', error);
            //     }
            // );
            this.confPost.getTextEmbeddingGecko().subscribe(res => {
                const temp: any = res;
                if (temp) {
                    this.geckoEmbeddings = temp;
                }
            });
        }
    }

    async getConnectorsData(): Promise<void> {
        try {
            const data = await this.connectorsService.getRawDataKeyTypes().toPromise();
            if (data) {
                this.connectors = data;
                this.componentLoading = false;
            } else {
                this.platform.handleErrorGracefully('', 'Error while retrieving plans.');
                this.componentLoading = false;
                this.router.navigateByUrl('/cognitive-search');
            }
        } catch (error) {
            throw error;
        }
    }

    updateSelectedConnectorsList(item: any) {
        this.selectedConnectorsList.push(item);
    }

    removeSelectedConnectorsList(index: any) {
        if (index !== -1) {
            this.selectedConnectorsList.splice(index, 1);
        }
    }

    onNextClick(): void {
        if (this.stepper) {
            const currentIndex = this.stepper.selectedIndex;
            this.isNextClicked = true;
            if (currentIndex < this.stepper.steps.length - 1) {
                this.stepper.selectedIndex = currentIndex + 1;
            } else {
                console.log('No next step available.');
            }
        }
    }

    deploy() {
        if (this.planName !== '' && this.version !== '') {
            if (!this.checkDisabled(1)) {
                if (!this.checkDisabled(2)) {
                    if (!this.checkDisabled(3)) {
                        if (!this.checkDisabled(4)) {
                            if (!this.checkDisabled(5)) {
                                const payload = {
                                    plan_name: this.planName,
                                    version: this.version,
                                    category: this.category,
                                    description: this.description,
                                    created_at: Date.now(),
                                    last_updated_at: Date.now(),
                                    status: 'Initializing',
                                    executors: {
                                        dataSource: {
                                            serviceProviders: this.selectedConnectorsList
                                        },
                                        cloudProvider: {
                                            cloud_provider: this.selectedProvider,
                                            projectName: this.project_name,
                                            location: this.location,
                                            bucketName: this.bucket_name,
                                        },
                                        indexConfiguration: {
                                            embedding: this.selectedEmbedding,
                                            dataFormat: this.selectedDataFormat,
                                            fileType: this.selectedFileType,
                                            chunkingStrategy: this.selectedChunkingStrategy,
                                            overlapEnabled: this.overlapEnabled,
                                            chunkOverlap: this.chunkOverlap,
                                            chunkSize: this.chunkSize,
                                            indexDisplayName: this.indexDisplayName,
                                            indexDescription: this.indexDescription,
                                            dimensions: this.dimensions,
                                            algorithmConfig: this.algorithmConfig,
                                            leafNodeEmbeddingCount: this.leafNodeEmbeddingCount,
                                            fractionLeafNodesToSearch: this.fractionLeafNodesToSearch,
                                            approximateNeighborsCount: this.approximateNeighborsCount,
                                            distanceMeasureType: this.distanceMeasureType,
                                            shardSize: this.shardSize,
                                            indexEndpointDisplayName: this.indexEndpointDisplayName,
                                            indexEndpointDescription: this.indexEndpointDescription,
                                        }
                                    },
                                    partner: localStorage.getItem('partner'),
                                    account: localStorage.getItem('account')
                                };
                                // console.log(payload);
                                const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                                    maxWidth: '95vw',
                                    maxHeight: '60vh',
                                });
                                this.confPost.postEnterprisePlans(payload).subscribe(res => {
                                    loaderDialog.close();
                                    this.router.navigateByUrl('/cognitive-search');
                                    // const wf_payload = {
                                    //     id: res['upsertedId'],
                                    //     tenantId: 'dev-vikram-dev-vikram',
                                    //     processId: 'Deploy_Enterprise_Plan'
                                    // };
                                    // this.confPost.invokeWorkflow(wf_payload).subscribe(response => {
                                    //     loaderDialog.close();
                                    //     this.router.navigateByUrl('/enterprise-search');
                                    //
                                    // }, err => {
                                    //     loaderDialog.close();
                                    //     // this.platform.handleErrorGracefully('', 'Error while invoking workflow');
                                    //     this.router.navigateByUrl('/enterprise-search');
                                    //
                                    // });
                                }, err => {
                                    loaderDialog.close();
                                    this.platform.handleErrorGracefully('', 'Error while adding Enterprise Search Plan');
                                });

                            } else {
                                this.platform.handleErrorGracefully('', 'Please enter the required create index endpoint fields');
                            }

                        } else {
                            this.platform.handleErrorGracefully('', 'Please enter the required create index fields');
                        }

                    } else {
                        this.platform.handleErrorGracefully('', 'Please enter the required index configuration fields');
                    }

                } else {
                    this.platform.handleErrorGracefully('', 'Please enter the required cloud provider fields');
                }

            } else {
                this.platform.handleErrorGracefully('', 'Please add the required data source');
            }


        } else {
            this.platform.handleErrorGracefully('', 'Please enter all the required fields');
        }
    }

    checkDisabled(step) {
        switch (step) {
            case 1:
                if (this.selectedConnectorsList.length > 0) {
                    return false;
                }
                return true;
            case 2:
                if (this.selectedProvider && this.project_name && this.location && this.bucket_name) {
                    return false;
                }
                return true;

            case 3:
                if (this.selectedEmbedding && this.selectedDataFormat && this.selectedChunkingStrategy) {
                    return false;
                }
                return true;

            case 4:
                if (this.indexDisplayName && this.indexDescription && this.dimensions && this.algorithmConfig
                    && this.approximateNeighborsCount && this.distanceMeasureType && this.shardSize) {
                    return false;
                }
                return true;

            case 5:
                if (this.indexEndpointDisplayName && this.indexEndpointDescription) {
                    return false;
                }
                return true;
            default:
                return true;

        }

        return true;
    }


}
